(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["deen-customer-quotes"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function (e) {
  var b = e.target.closest('[data-deen-cq-open]'); if (!b) return;
  b.closest('.deen-cq').classList.add('is-open');
  b.parentNode.style.display = 'none';
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["deen-lookbook-grid"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function (e) {
  var b = e.target.closest('[data-deen-lb-open]'); if (!b) return;
  b.closest('.deen-lb').classList.add('is-open');
  b.parentNode.style.display = 'none';
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["deen-reviews"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function (e) {
  var open = e.target.closest('[data-deen-open]');
  if (open) {
    var r = open.closest('.deen-reviews-wrap');
    r.classList.add('is-open');
    open.parentNode.style.display = 'none';
    return;
  }
  var btn = e.target.closest('[data-deen-more]'); if (!btn) return;
  var root = btn.closest('.deen-reviews-wrap');
  var hidden = root.querySelectorAll('.deen-hidden-review');
  for (var i = 0; i < hidden.length && i < 20; i++) hidden[i].classList.remove('deen-hidden-review');
  if (!root.querySelector('.deen-hidden-review')) btn.style.display = 'none';
});
function deenAvatars() {
  document.querySelectorAll('.deen-reviews-wrap .deen-name').forEach(function (n) {
    if (n.querySelector('.deen-av')) return;
    var t = (n.textContent || '').trim();
    if (!t) return;
    var a = document.createElement('span');
    a.className = 'deen-av';
    a.setAttribute('aria-hidden', 'true');
    a.textContent = t.charAt(0).toUpperCase();
    n.insertBefore(a, n.firstChild);
  });
}
deenAvatars();
document.addEventListener('DOMContentLoaded', deenAvatars);

function deenRvc(root) {
  if (root.getAttribute('data-ready')) return;
  var t = root.querySelector('.deen-image-grid');
  if (!t) return;
  root.setAttribute('data-ready', '1');
  var cards = t.querySelectorAll('.deen-card');
  var prev = root.querySelector('[data-rvc-dir="-1"]');
  var next = root.querySelector('[data-rvc-dir="1"]');
  function step() { return cards[0] ? cards[0].getBoundingClientRect().width + 14 : t.clientWidth * 0.8; }
  function upd() {
    prev.disabled = t.scrollLeft < 4;
    next.disabled = t.scrollLeft + t.clientWidth >= t.scrollWidth - 4;
  }
  prev.addEventListener('click', function () { t.scrollBy({ left: -step(), behavior: 'smooth' }); });
  next.addEventListener('click', function () { t.scrollBy({ left: step(), behavior: 'smooth' }); });
  t.addEventListener('scroll', upd, { passive: true });
  window.addEventListener('resize', upd);
  upd();
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if ('IntersectionObserver' in window && !reduce) {
    root.classList.add('is-anim');
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { root: t, threshold: 0.12 });
    cards.forEach(function (c, i) {
      var im = c.querySelector('.deen-card-image');
      if (im) im.style.transitionDelay = (Math.min(i, 5) * 80) + 'ms';
      io.observe(c);
    });
  }
  if (reduce || !('IntersectionObserver' in window)) return;
  var paused = false, visible = false;
  ['mouseenter', 'touchstart', 'focusin'].forEach(function (ev) { root.addEventListener(ev, function () { paused = true; }, { passive: true }); });
  ['mouseleave', 'touchend', 'focusout'].forEach(function (ev) { root.addEventListener(ev, function () { paused = false; }, { passive: true }); });
  new IntersectionObserver(function (es) { visible = es[0].isIntersecting; }, { threshold: 0.3 }).observe(root);
  setInterval(function () {
    if (paused || !visible) return;
    if (t.scrollLeft + t.clientWidth >= t.scrollWidth - 4) t.scrollTo({ left: 0, behavior: 'smooth' });
    else t.scrollBy({ left: step(), behavior: 'smooth' });
  }, 3600);
}
function deenRvcAll() { document.querySelectorAll('[data-deen-rvc]').forEach(deenRvc); }
deenRvcAll();
document.addEventListener('DOMContentLoaded', deenRvcAll);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["deen-ugc"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function (e) {
  var b = e.target.closest('[data-ugc-dir]'); if (!b) return;
  var t = b.parentNode.querySelector('.deen-ugc__track');
  t.scrollBy({ left: parseInt(b.dataset.ugcDir, 10) * t.clientWidth * 0.8, behavior: 'smooth' });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hz-social-proof"] && !Shopify.designMode) return;
  try {
    
(function () {
  function fmt(v) { if (v >= 1000000) return (v / 1000000).toFixed(1).replace('.0', '') + 'M+'; if (v >= 1000) return (v / 1000).toFixed(1).replace('.0', '') + 'K+'; return v.toLocaleString() + '+'; }
  function animate(el) {
    var target = parseInt(el.dataset.target, 10) || 0, dur = 1600, start = null;
    function step(ts) { if (!start) start = ts; var p = Math.min((ts - start) / dur, 1), e = 1 - Math.pow(1 - p, 3); el.textContent = fmt(Math.floor(e * target)); if (p < 1) requestAnimationFrame(step); else el.textContent = fmt(target); }
    requestAnimationFrame(step);
  }
  function run() {
    var counters = document.querySelectorAll('.deen-sp .deen-counter');
    if (!counters.length) return;
    if (!('IntersectionObserver' in window)) { counters.forEach(animate); return; }
    var obs = new IntersectionObserver(function (entries) { entries.forEach(function (en) { if (en.isIntersecting) { animate(en.target); obs.unobserve(en.target); } }); }, { threshold: 0.4 });
    counters.forEach(function (c) { obs.observe(c); });
  }
  if (document.readyState !== 'loading') run(); else document.addEventListener('DOMContentLoaded', run);
})();

  } catch(e) { console.error(e); }
})();
})();
